import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import FabAdd from "../../components/FabAdd";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Divider from "@mui/material/Divider";

import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell
} from "@mui/material";

import { observer, inject } from "mobx-react";

import { getCurrentOrg } from "../../utils/operations.js";

import API from '../../utils/api';
import { api2Admins } from '../../utils/operations';

const StyledTableRow = ({ userID, history, children, ...restProps }) => {
  const editData = value => history.push("/editadmin/" + value);
  return (
    <TableRow
      {...restProps}
      onMouseDown={() => editData(userID)}
      sx={{
        cursor: 'pointer',
        '&:nth-of-type(odd)': { backgroundColor: 'rgba(142, 195, 242, 0.4)' },
        '&:hover': { backgroundColor: '#f5f5f5' },
      }}
    >
      {children}
    </TableRow>
  );
};

const Admins = ({ Auth, history }) => {
  const [showProgress, setShowProgress] = useState(true);
  const [admins, setAdmins] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!Auth.can('administrators')) { history.push("/children"); return; }
    axios.all([
      API.get(getCurrentOrg),
      API.get(api2Admins)
    ]).then(axios.spread((organisations, adminsRes) => {
      const orgs = organisations.data.resource;
      const adms = adminsRes.data.admins.map(a => {
        const a_org = orgs.find(o => o.id === a.organisation_id);
        return { ...a, org_name: a_org ? a_org.name : '' };
      });
      setAdmins(adms);
      setShowProgress(false);
    }));
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return admins;
    return admins.filter(a =>
      a.name?.toLowerCase().includes(q) ||
      a.email?.toLowerCase().includes(q)
    );
  }, [admins, search]);

  return (
    <div style={{ margin: "auto", overflowX: 'scroll' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <TextField
          placeholder="Search by name or email…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          size="small"
          sx={{ width: 320 }}
          inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', spellCheck: 'false' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <Divider style={{ marginTop: 10 }} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={40}></TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>School</TableCell>
            <TableCell>Additional Access</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filtered.map((row, index) => (
            <StyledTableRow key={row.id} userID={row.id} history={history}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.role_name || '—'}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.org_name}</TableCell>
              <TableCell>{row.organisations.map((o) => <div key={o.id}>{o.name}</div>)}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
      {showProgress && <LinearProgress />}
      <FabAdd onClick={() => history.push("/newadmin/")} />
    </div>
  );
};

export default inject("Auth")(observer(Admins));

